import { render, staticRenderFns } from "./HealthPolicySection.vue?vue&type=template&id=32d545d0&scoped=true"
import script from "./HealthPolicySection.vue?vue&type=script&lang=js"
export * from "./HealthPolicySection.vue?vue&type=script&lang=js"
import style0 from "./HealthPolicySection.vue?vue&type=style&index=0&id=32d545d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d545d0",
  null
  
)

export default component.exports